module.exports = __webpack_public_path__ + "img/Word.aa7d0aa.webp";